<template>
  <div class="d-flex text-lg py-1 border-top">
    <div class="w-20x border-right">
      <div class="text-center text-lg text-monospace">
        {{ item.digits }} <i
          class="fas"
          :class="iconType(item.type)"
        />
      </div>
    </div>
    <div class="w-20x border-right">
      <div class="text-center text-lg text-monospace">
        {{ item.amount }}
      </div>
    </div>
    <div
      v-if="item.type != '4upper'"
      class="w-20x border-right"
    >
      <div class="text-center text-lg text-monospace">
        {{ item.paybaht }}
      </div>
    </div>
    <div
      v-if="item.type != '4upper'"
      class="w-40x"
    >
      <div class="text-center text-lg text-monospace">
        {{
          Intl.NumberFormat({ style: 'currency', currency: 'THB'}).format(item.amount * item.paybaht)
        }}
      </div>
    </div>
    <div
      v-else
      class="w-60x"
    >
      <div class="text-center text-lg text-monospace">
        1 ชุด
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BetRecap',
  props: {
    item: '',
    masterSlug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
    console.log(this.item);
  },
  methods: {
    iconType(slug) {
      switch (slug) {
        case '4upper':
          return 'fa-arrow-up';
          break;
        case '3upper':
          return 'fa-arrow-up';
          break;
        case '3shuffle':
          return 'fa-sync-alt';
          break;
        case '3front':
          return 'fa-arrow-left';
          break;
        case '3back':
          return 'fa-arrow-right';
          break;
        case '2upper':
          return 'fa-arrow-up';
          break;
        case '2under':
          return 'fa-arrow-down';
          break;
        case 'any_upper':
          return 'fa-arrow-up';
          break;
        default:
          return 'fa-arrow-down';
          break;
      }
    },
  },
};
</script>
